var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRandbMusic = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Vinyl-Record-Player--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Vinyl Record Player Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.75a2.75 2.75 0 1 0 2.75 2.75A2.75 2.75 0 0 0 10 10.75Zm0 4a1.25 1.25 0 1 1 1.25 -1.25A1.25 1.25 0 0 1 10 14.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3a2.5 2.5 0 0 0 -5 0v2a1.5 1.5 0 0 0 1.29 1.48 0.26 0.26 0 0 1 0.21 0.25V12a0.27 0.27 0 0 1 -0.06 0.17l-4.25 4.72a1 1 0 0 0 0.14 1.33 1 1 0 0 0 1.41 -0.07l4.5 -5a1 1 0 0 0 0.26 -0.65V6.73a0.26 0.26 0 0 1 0.21 -0.25A1.5 1.5 0 0 0 22.5 5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.72 6.5a0.26 0.26 0 0 0 -0.19 0.1 3.1 3.1 0 0 1 -0.91 0.93 0.22 0.22 0 0 0 -0.12 0.21v4.76a2.51 2.51 0 0 1 -0.64 1.67l-4.5 5a2.5 2.5 0 0 1 -3 0.57 0.25 0.25 0 0 0 -0.25 0 7.5 7.5 0 1 1 2.89 -8.9 0.25 0.25 0 0 0 0.24 0.16 0.25 0.25 0 0 0 0.25 -0.25v-3a0.22 0.22 0 0 0 -0.12 -0.21A3 3 0 0 1 16 5V3.75a0.25 0.25 0 0 0 -0.25 -0.25H1.5A1.5 1.5 0 0 0 0 5v17a1.5 1.5 0 0 0 1.5 1.5h21A1.5 1.5 0 0 0 24 22V6.78a0.27 0.27 0 0 0 -0.28 -0.28Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRandbMusic);
export default ForwardRef;